import React from 'react';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const LabelContent = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    forId
  } = _ref;
  return /*#__PURE__*/_jsx("label", {
    ref: ref,
    htmlFor: forId,
    style: staticStyles.inheritCursor,
    children: children
  });
});
LabelContent.displayName = 'LabelContent';
LabelContent.propTypes = {
  children: PropTypes.string,
  forId: PropTypes.string
};

// Note that <label> is not React Native, so we can't use `StyleSheet.create` here
const staticStyles = {
  inheritCursor: {
    cursor: 'inherit'
  }
};
export default LabelContent;